export const getters = {
  getEOI: (state) => {
    return state;
  },
  getEOIId: (state) => {
    return state.ua_icexpressionofinterestid;
  },
  getEOISubmitted: (state) => {
    return state.ua_submiteoi;
  },
  getEOIStatus: (state) => {
    return state.ua_currentstatus;
  },
  getEOICurrentStep: (state) => {
    return state.ua_currentpageinapplication;
  },
  getReadyForFunding: (state) => {
    return state.ua_readyforfundinglarge;
  },
  getSharepointFolderName: (state) => {
    return state.ua_sharepointfoldername;
  },
  getCompanyName: (state) => {
    return state.ua_companyname;
  }
};
